var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 47,
    viewBox: "0 0 12 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.657,
    y1: 0.053,
    x2: 0.365,
    y2: 0.985,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21458",
    "data-name": "Path 21458",
    d: "M1084.232,224.583c-.46-12.406-5.139-19.212-5.907-19.212h-.055c-.765,0-5.444,6.806-5.9,19.212s1.564,22.2,2.838,25.166c.945,2.2,1.3,2.622,2.121,2.622s.768-.518.768-.9,0-.992.2-.992h0c.2,0,.2.613.2.992s-.052.9.768.9,1.174-.423,2.121-2.622c1.274-2.962,3.3-12.76,2.838-25.166m-3.92,18.391h-3.146a.934.934,0,0,1-.914-.947V224.29a.012.012,0,0,1,0-.009.761.761,0,0,1,.927-.723c.338.073.677.152,1.012.246a5.31,5.31,0,0,1,2.463,1.374,2.16,2.16,0,0,1,.558,1.488c0,3.121.012,15.362.012,15.362a.932.932,0,0,1-.915.947m1.1-20.4a3.507,3.507,0,0,0-2.228-1.683,14.807,14.807,0,0,1-2.621-.8,2.552,2.552,0,0,1-1.408-2.274,2.643,2.643,0,0,1,2.9-1.238,4.293,4.293,0,0,1,2.676,2.287,7.049,7.049,0,0,1,.683,3.711",
    transform: "translate(-1072.298 -205.371)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardIcon);
export default __webpack_public_path__ + "static/media/BoardIcon.0df9eecafdfe71b81c3433400a1f8c3d.svg";
export { ForwardRef as ReactComponent };